export default "__VITE_ASSET__e9007871__"